
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SvgInclude extends Vue {
  @Prop({ default: false })
  private includeInner!: boolean;
}
